// @generated by protobuf-ts 2.9.0 with parameter generate_dependencies,force_optimize_code_size,long_type_string,ts_nocheck
// @generated from protobuf file "feature/v1/feature.proto" (package "feature.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
//
// Feature flag RPCs and protos
//
import type { RpcTransport } from "@protobuf-ts/runtime-rpc";
import type { ServiceInfo } from "@protobuf-ts/runtime-rpc";
import { FeatureFlagService } from "./feature";
import type { SetFeatureDefaultResponse } from "./feature";
import type { SetFeatureDefaultRequest } from "./feature";
import type { GetFeatureDefaultsResponse } from "./feature";
import type { GetFeatureDefaultsRequest } from "./feature";
import type { SetFeatureResponse } from "./feature";
import type { SetFeatureRequest } from "./feature";
import { stackIntercept } from "@protobuf-ts/runtime-rpc";
import type { GetFeaturesResponse } from "./feature";
import type { GetFeaturesRequest } from "./feature";
import type { UnaryCall } from "@protobuf-ts/runtime-rpc";
import type { RpcOptions } from "@protobuf-ts/runtime-rpc";
/**
 * @generated from protobuf service feature.v1.FeatureFlagService
 */
export interface IFeatureFlagServiceClient {
    /**
     * @generated from protobuf rpc: GetFeatures(feature.v1.GetFeaturesRequest) returns (feature.v1.GetFeaturesResponse);
     */
    getFeatures(input: GetFeaturesRequest, options?: RpcOptions): UnaryCall<GetFeaturesRequest, GetFeaturesResponse>;
    /**
     * @generated from protobuf rpc: SetFeature(feature.v1.SetFeatureRequest) returns (feature.v1.SetFeatureResponse);
     */
    setFeature(input: SetFeatureRequest, options?: RpcOptions): UnaryCall<SetFeatureRequest, SetFeatureResponse>;
    /**
     * @generated from protobuf rpc: GetFeatureDefaults(feature.v1.GetFeatureDefaultsRequest) returns (feature.v1.GetFeatureDefaultsResponse);
     */
    getFeatureDefaults(input: GetFeatureDefaultsRequest, options?: RpcOptions): UnaryCall<GetFeatureDefaultsRequest, GetFeatureDefaultsResponse>;
    /**
     * @generated from protobuf rpc: SetFeatureDefault(feature.v1.SetFeatureDefaultRequest) returns (feature.v1.SetFeatureDefaultResponse);
     */
    setFeatureDefault(input: SetFeatureDefaultRequest, options?: RpcOptions): UnaryCall<SetFeatureDefaultRequest, SetFeatureDefaultResponse>;
}
/**
 * @generated from protobuf service feature.v1.FeatureFlagService
 */
export class FeatureFlagServiceClient implements IFeatureFlagServiceClient, ServiceInfo {
    typeName = FeatureFlagService.typeName;
    methods = FeatureFlagService.methods;
    options = FeatureFlagService.options;
    constructor(private readonly _transport: RpcTransport) {
    }
    /**
     * @generated from protobuf rpc: GetFeatures(feature.v1.GetFeaturesRequest) returns (feature.v1.GetFeaturesResponse);
     */
    getFeatures(input: GetFeaturesRequest, options?: RpcOptions): UnaryCall<GetFeaturesRequest, GetFeaturesResponse> {
        const method = this.methods[0], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetFeaturesRequest, GetFeaturesResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: SetFeature(feature.v1.SetFeatureRequest) returns (feature.v1.SetFeatureResponse);
     */
    setFeature(input: SetFeatureRequest, options?: RpcOptions): UnaryCall<SetFeatureRequest, SetFeatureResponse> {
        const method = this.methods[1], opt = this._transport.mergeOptions(options);
        return stackIntercept<SetFeatureRequest, SetFeatureResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetFeatureDefaults(feature.v1.GetFeatureDefaultsRequest) returns (feature.v1.GetFeatureDefaultsResponse);
     */
    getFeatureDefaults(input: GetFeatureDefaultsRequest, options?: RpcOptions): UnaryCall<GetFeatureDefaultsRequest, GetFeatureDefaultsResponse> {
        const method = this.methods[2], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetFeatureDefaultsRequest, GetFeatureDefaultsResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: SetFeatureDefault(feature.v1.SetFeatureDefaultRequest) returns (feature.v1.SetFeatureDefaultResponse);
     */
    setFeatureDefault(input: SetFeatureDefaultRequest, options?: RpcOptions): UnaryCall<SetFeatureDefaultRequest, SetFeatureDefaultResponse> {
        const method = this.methods[3], opt = this._transport.mergeOptions(options);
        return stackIntercept<SetFeatureDefaultRequest, SetFeatureDefaultResponse>("unary", this._transport, method, opt, input);
    }
}
